module.exports = __webpack_public_path__ + "static/media/whitemob.904102d4.svg";